// extracted by mini-css-extract-plugin
module.exports = {"img":"style_img__on8wP","imgWrapper":"style_imgWrapper__1U7np","customImg":"style_customImg__33foD"};